module.exports = __webpack_public_path__ + "static/media/change-direction-blue-icon-vertical.13b6052a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/change-direction-blue-icon-vertical.svg
// module id = 227
// module chunks = 0